import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioExameCadastrado(queryParms) {
            return repository.get(`${baseUrl}/relatorio-exame-cadastrado?${urlUtil.serialize(queryParms)}`, headers) 
        },    
    }
}

